import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Input } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, TouchableOpacity } from 'react-native';
import trackerApi from '../../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useIsFocused } from "@react-navigation/native";
import * as RootNavigation from '../../../../root.navigation.js';

const width = Dimensions.get('window').width;
const TikIcon = (props) => (
  <Icon {...props} name='done-all-outline'
  style={[props.style, {width:18,height:18 }]}
  fill = '#417CBE'
  />
);
const BackIcon = (props) => (
  <Icon {...props} name='arrow-forward-outline'
  style={[props.style, {width:30,height:30 }]}
  fill = '#417CBE'
  />
);


export const Messages = (props) => {
  const scrollViewRef = React.useRef();
  const [messages, setMessages] = useState([]);
  const isVisible = useIsFocused();

  React.useEffect(()=>{
    getData()
  },[isVisible])
  const getData = async()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/tickets/replies', {query: props.query.id}, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.allData) setMessages(response.data.allData);
    else null

    const response2 = await trackerApi.post('/update/tickets/seen_replies', {query: props.query.id}, {
      headers: {Authorization: `Bearer ${token}`}
    });
  }

  return (

    <ScrollView
      ref={scrollViewRef}
      onContentSizeChange={() => scrollViewRef.current.scrollToEnd({ animated: true })}
   >

      <Layout style={styles.container} level='4' >
      <Layout level='2' style={{flexDirection:'row', alignItems:'center',marginBottom:10, justifyContent:'space-between', width: width-30, borderRadius:10, borderColor:'#134A93', borderWidth:1, paddingVertical:5}}>
      <TouchableOpacity style={{marginHorizontal:5}} onPress={()=> RootNavigation.navigate('support')}>
      <BackIcon />
      </TouchableOpacity>
      <Layout level='2' style={{alignItems:'center', justifyContent:'space-between'}}>
        <Text>تیکت شماره {props.query.id}</Text>
        <Text appearance='hint'>عنوان: {props.query.topic}</Text>
      </Layout>
      <Layout level='2' style={{marginHorizontal:5, width:24}}/>
      </Layout>
      {/*<Layout level='4' style={{alignItems:'center'}}>
        <Text appearance='hint'> امروز</Text>
      </Layout>*/}
    {/*  <Layout level='4' style={styles.me}>
        <Layout level='4' style={{alignItems:'flex-end'}}>
          <Text appearance='hint' category='c2'> 22:09 </Text>
          <TikIcon />
        </Layout>
        <Layout style={styles.meBox}>
          <Text >{props.query.message}</Text>
        </Layout>
      </Layout>*/}
      { (messages.length>0?
        messages.map((data, index)=>{
        if(data.replied_by_id== props.user) return(
          <Layout level='4' style={styles.me} key={index}>
            <Layout level='4' style={{alignItems:'flex-end'}}>
              <Text appearance='hint' category='c2'> {data.reply_date ? data.reply_date.split('T')[1]: ''} </Text>
              <TikIcon />
            </Layout>
            <Layout style={styles.meBox}>
              <Text >{data.reply_message}</Text>
            </Layout>
          </Layout>
        )
        else return(
            <Layout level='4' style={styles.you} key={index}>
              <Layout style={styles.youBox}>
                <Text style={{color:'#CEE8F9'}}>{data.reply_message}</Text>
              </Layout>
              <Text appearance='hint' category='c2'> 22:09 </Text>
            </Layout>
        )
      })
      :null)
      }


      </Layout>

      </ScrollView>

  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'flex-start',
    paddingTop:15
  },
  me:{
    flexDirection:'row',
    alignItems:'flex-start',
    justifyContent:'flex-start',
    width ,
    paddingHorizontal:15
  },
  meBox:{
    borderBottomLeftRadius:10,
    borderBottomRightRadius:10,
    borderTopRightRadius:10,
    paddingVertical:5,
    paddingHorizontal:10,
    marginTop:6,
    marginLeft:5,
    borderWidth:1,
    borderColor:'#417CBE',
    maxWidth: width*0.6
  },
  you:{
    flexDirection:'row',
    alignItems:'flex-start',
    justifyContent:'flex-end',
    width ,
    paddingHorizontal:15
  },
  youBox:{
    borderBottomLeftRadius:10,
    borderBottomRightRadius:10,
    borderTopLeftRadius:10,
    paddingVertical:5,
    paddingHorizontal:10,
    marginTop:6,
    marginRight:5,
    backgroundColor:'#417CBE',
    maxWidth: width*0.6

  }
});
